import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';

const ExpiredOrderModal = ({ isOpen, onClose, onAcknowledged, onManageDisableScrolling }) => {
  const strong = (
    <strong>
      <FormattedMessage id="ExpiredOrderModal.expiredOrderText.strong" />
    </strong>
  );
  const strong1 = (
    <strong>
      <FormattedMessage id="ExpiredOrderModal.expiredOrderText.strong1" />
    </strong>
  );
  const strong2 = (
    <strong>
      <FormattedMessage id="ExpiredOrderModal.expiredOrderText.strong2" />
    </strong>
  );

  return (
    <Modal
      id="ExpiredOrderModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      usePortal
    >
      <div>
        <p>
          <FormattedMessage id="ModalMissingInformation.expiredOrderTitle" />
        </p>
        <p>
          <FormattedMessage
            id="ModalMissingInformation.expiredOrderText"
            values={{ strong, strong1, strong2 }}
          />
        </p>
        <Box
          sx={{
            marginTop: '1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <Button color="primary" onClick={onAcknowledged} variant="contained">
            <FormattedMessage id="ModalMissingInformation.acknowledged" />
          </Button>
          <Button color="secondary" onClick={onClose} variant="outlined">
            <FormattedMessage id="ModalMissingInformation.close" />
          </Button>
        </Box>
      </div>
    </Modal>
  );
};

export default ExpiredOrderModal;
